import { useCallback } from 'react'
import axios from 'axios'

const useViaCepClient = () => {
  const getInfoByCep = useCallback(async (cep) => axios.get(`/client/ViaCEPWS/${cep}`).then((res) => res?.data), [])

  return useCallback(() => ({
    getInfoByCep,
  }), [
    getInfoByCep,
  ])
}

export default useViaCepClient
